import { BaseModel } from '@nimmsta/ng-commons-lib/models';
import { Platform } from './platform';

export interface Configuration extends BaseModel {
  name: string;
  description: string;
  downloadLink: string;
  version: number;
  platform: Platform;
  organizationIds: string[];
  state: State;
}

export enum State {
  READY = 'READY',
  SUBMITTED = 'SUBMITTED',
}
